import { makeStyles } from '@material-ui/core'

export default makeStyles({
  root: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  icon: {
    transform: 'scale(1.5)',
    color: '#fff',
    width: 22,
    height: 22
  },
  logoutIcon: {
    marginTop: '-.2rem',
    marginRight: '.2rem'
  }
})
